module.exports = __webpack_public_path__ + "img/1537389681.d9a4fe80.jpg";